export const STRIP_START_AND_END_QUOTES = /(^"|"$)/g;
export const PRODUCT_SKU_REGEX = /\/?[a-z\d-]+-(\d{8})$/;
export const DIGITS_ONLY = /\D/g;
export const DIGITS_AND_LETTERS = /[^\w]/g;
export const DIGITS_LETTERS_AND_SPECIAL_CHARS = /\s/g;
export const ENDING_FORWARD_SLASHES = /\/+$/;
export const TYPESENSE_SORTING_TYPE_SPLIT = /(?=[A-Z])/;
export const VOLUME_LESS_OR_EQUAL_THAN = /quantity >= (?<volume>\d+)/;
export const DISTINCT_PRODUCTS_CART_PREDICATE =
  /custom\.numberOfDistinctProducts\s*(?<operator>>=|>)\s*(?<count>\d+)/;
export const CHUNK_PATH = /\/_nuxt\/.*\.js$/;
export const CMS_PAGE_LOCALE = /([a-z]{2}-[A-Z]{2})$/;
export const MONETARY_COHORT = /"(monetary-cohort-(?:base-tier|tier-\d+))"/;
export const URL_PROTOCOL_SCHEME = /^[a-zA-Z][a-zA-Z0-9+.-]*:/;
export const PROMO_CODE_TAG = /<promoCode>(.*?)<\/promoCode>/g;
export const COUNTRY_CODE_PATTERN = /^[A-Za-z]{2}$/;
export const ANY_VAT_NUMBER_PATTERN = /^[A-Za-z0-9.,\-\s]{3,50}$/;
export const EXPONDO_EMAIL_DOMAIN_PATTERN = /@expondo\./i;

